module.exports = __webpack_public_path__ + "img/icon-sidebar-checkups.f3da7435.svg";